import type { ScrapingRunListResponse } from '../types';

import { internalApiClient } from '@/shared/api-client/internal-api-client';
import { omitNullish } from '@/shared/utils/omit-nullish';

export type ListScrapingIntentRunsParams = {
  intentId: string;
  limit?: number;
  cursor?: string;
};

export async function listScrapingIntentRuns({
  intentId,
  limit,
  cursor,
}: ListScrapingIntentRunsParams): Promise<ScrapingRunListResponse> {
  const response = await internalApiClient.get<ScrapingRunListResponse>(
    `scraping-intents/${intentId}/runs`,
    {
      searchParams: omitNullish({ limit, cursor }),
    },
  );

  return response.json();
}
